module.exports = __webpack_public_path__ + "static/media/RMC-cta-001.9b1282d2.jpg";